<script>
import StatsService from "@/api/services/stats.service";
import { dataPerCalendarWeekChart } from "@/redem/stats/result-charts.js";
import Multiselect from "vue-multiselect";
import DataFetchingErrorWidget from "@/shared/components/widgets/data-fetching-error"
import CompanyService from "@/api/services/company.service.js";

export default {
  components: {
    Multiselect,
    DataFetchingErrorWidget
  },
  data() {
    return {
      dataPerCalendarWeekChartData: {
        name: "Number of Data Files",
        data: []
      },
      dataPerCalendarWeekChartOptions: null,
      years: [2021, 2022, 2023, 2024, 2025],
      allCompanies: null,
      /****** Filter Options *****/
      selectedCompany: null,
      selectedYear: null,
      /****** Operational Data *****/
      isComponentLoading: false,
      errorInFetchingData: false
    }
  },
  async mounted() {
    // 1. Create chart option
    this.dataPerCalendarWeekChartOptions = new dataPerCalendarWeekChart()

    // 2. Set selectedYear
    this.selectedYear = new Date().getFullYear()

    // 3. Fetch all companies
    await this.fetchAllCompanies()

    // 4. Fetching data
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        // 1. Enable loading
        this.isComponentLoading = true

        // 2. Fetch Data
        const response = await StatsService.getDatafilesPerCalendarWeek(
          this.selectedYear,
          this.selectedCompany ? this.selectedCompany.id : null
        )

        // 3. Make Chart Data variables to default values 
        this.dataPerCalendarWeekChartOptions.chartOptions.xaxis.categories = []
        this.dataPerCalendarWeekChartData.data = []

        // 4. Set Data for the Chart
        if(response && response.length > 0) {
          for(let i=0; i < response.length; i++) {
            this.dataPerCalendarWeekChartOptions.chartOptions.xaxis.categories.push(response[i].week)
            this.dataPerCalendarWeekChartOptions.chartOptions.yaxis.title.text = "Number of Data Files"
            this.dataPerCalendarWeekChartData.data.push(response[i].numberOfDatafiles)
          }
        }
        
        // 5. Enable loading
        this.isComponentLoading = false
      } catch(error) {
        this.isComponentLoading = false
        this.errorInFetchingData = true
      }
    },
    async fetchAllCompanies() {
      this.allCompanies = await CompanyService.getAllCompnies();
    },
    async changeDataOneOfTheFilters() {
      await this.fetchData()
    }
  }
}
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="card-title">
        <div class="row">
          <div class="col-md-8">
            Number of Datasfiles Per Calendar Week
          </div>

          <!-- Company -->
          <div class="col-md-2" v-if="allCompanies">
            <div class="form-group">
              <label> {{ $t("datafiles.ownedCompany.label")}} </label> 
              <multiselect
                v-model="selectedCompany"
                :options="allCompanies"
                :close-on-select="true"
                track-by="name"
                :searchable="true"
                label="name"
                :placeholder="$t('datafiles.ownedCompany.placeholder')"
                @input="changeDataOneOfTheFilters()"
              >
              </multiselect>
            </div>
          </div>

          <!-- Year -->
          <div class="col-md-2">
            <div class="form-group">
              <label> Year </label> 
              <multiselect
                v-model="selectedYear"
                deselect-label="Can't remove this value"
                :options="years"
                :searchable="false"
                :close-on-select="true"
                :allowEmpty="false"
                placeholder="Pick a value"
                @input="changeDataOneOfTheFilters()"
              >
              </multiselect>
            </div>
          </div>
        </div>
        
      </div>

      <!-- Display Chart -->
      <div class="card-text" v-if="!isComponentLoading">
        <apexchart
          ref="distributionChart"
          class="apex-charts"
          dir="ltr"
          type="bar"
          height="300"
          :series="[dataPerCalendarWeekChartData]"
          :options="dataPerCalendarWeekChartOptions.chartOptions"
        ></apexchart>
      </div>

      <!-- Display Data Fetching Error -->
      <div class="card-text" v-if="!isComponentLoading && errorInFetchingData">
        <DataFetchingErrorWidget/>
      </div>

      <!-- Display Loading -->
      <div class="card-text" v-if="isComponentLoading">
        <div class="row justify-content-center mt-5">
          <b-spinner
            style="width: 5rem; height: 5rem"
            class="m-2"
            variant="mid"
            role="status"
          ></b-spinner>
        </div>
      </div>

    </div>
  </div>
</template>